import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import ViewPumpDomesticSO from "./PumpDomesticSO/ViewPumpDomesticSO";
import ViewPumpInternationalSO from "./PumpInternatinalSO/ViewPumpInternational";
import ViewAraiMFGSO from "./AraiMfgSo/ViewAraiMfgInt";
import ViewAraiMfgDomesticSO from "./AraiMfgDomesticSO/ViewAriMfgDomesticSO";

const ViewSalesOrder = () => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
        headers: authHeader(),
      });

      console.log(response);

      setEnquiryData(response.data);
      setProductType(response.data.salesordertype);
      setProductCategory(response.data.salesordercategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <ViewPumpDomesticSO enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewPumpInternationalSO enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <ViewAraiMfgDomesticSO enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewAraiMFGSO enquiryData={enquiryData} />;
      }
    }
    return null;
  }

  async function deleteEnquiry() {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(BASE_URL + "salesOrder/delete/" + id, {
            headers: authHeader(),
          })
          .then((response) => {
            if (response.data.length === 0) {
              Swal.fire(
                "Warning",
                "Enquiry present in another module. Delete operation has been cancelled.",
                "warning"
              );
            } else {
              console.log(response.data);
              navigate(`/salesOrderIndexTable/${pointindex}`);
              Swal.fire("Deleted!", "Deleted successfully.", "success");
            }
          })
          .catch((error) => {
            Swal.fire("Error", error.response.data, "error");
          });
      }
    });
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW</h6>
          <div>
            <strong>Type:</strong> {productType} | <strong>Category:</strong> {productCategory}
          </div>
          <div className="view-buttons">
            {productCategory === "Domestic" && enquiryData?.status !== "Converted" && (
              <Link to={`/sotodcconvert/${id}`}>
                <button className="button-70">Convert To DC</button>
              </Link>
            )}
            {productCategory === "International" && enquiryData?.status !== "Converted" && (
              <Link to={`/sotosalesconvert/${id}`}>
                <button className="button-70">Convert To Sales</button>
              </Link>
            )}
            <Link>
              {/* <button onClick={deleteEnquiry} className="button-70">
                DELETE
              </button> */}
            </Link>
            <Link to={`/editSalesOrder/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link>
            <Link to={`/salesOrderIndexTable/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {PageDisplay()}
      </Card>
  );
};

export default ViewSalesOrder;
